// Hook do pobierania dostępnych serwisów pól dodatkowych (AdditionalFieldsService)

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IAdditionalFieldsService {
  value: string;
  text: string;
}

interface IResponse {
  items: IAdditionalFieldsService[];
}

const getAdditionalFieldsServices = (): Promise<IResponse> =>
  axios.get('/dev-studio/process/additional-fields-services');

export const useGetAdditionalFieldsServices = (
  options?: UseQueryOptions<IResponse, IError>
) => useQuery<IResponse, IError>(['additionalFieldsServices'], () => getAdditionalFieldsServices(), options);
